import type { GameZoneId } from "@cold-case/shared/player-pose";

import type { ZoneId } from "./map-grid.js";

export type FollowWorldViewState = {
  outdoorZone: ZoneId;
  viewMode: "outdoor" | "interior";
  interiorBuildingId: string | null;
};

/** True when local scene already matches leader world mirror / zone_change target. */
export function isFollowWorldStateSynced(
  state: FollowWorldViewState,
  zone: GameZoneId,
  buildingId: string | null
): boolean {
  if (state.outdoorZone !== zone) return false;
  if (buildingId) {
    return state.viewMode === "interior" && state.interiorBuildingId === buildingId;
  }
  return state.viewMode === "outdoor";
}
